import { SanityImageObject } from '@sanity/image-url/lib/types/types';
import { fileUrl } from 'api';
import { FC } from 'react';

type VideoWrapperProps = {
  _type?: string;
  media?: SanityImageObject & {
    localMedia?: string;
  };
  localMedia?: string;
};

const VideoWrapper: FC<VideoWrapperProps> = ({ media, localMedia }) => {
  return (
    <div className="relative">
      <video
        muted
        loop
        autoPlay
        src={localMedia ? localMedia : fileUrl(media!).toString()}
        className="object-contain w-[384px]"
      />
    </div>
  );
};

export default VideoWrapper;
